import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export enum StatsMode {
  COMPLETE = 'complete',
  SELECTIVE = 'selective',
}

@Component({
  selector: 'ts-stats-settings',
  templateUrl: './stats-settings.component.html',
  styleUrls: ['./stats-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StatsSettingsComponent {
  @Input() statsMode: StatsMode;
  @Output() statsModeChanged = new EventEmitter<StatsMode>();

  public readonly StatsMode = StatsMode;

  public changeStatsMode(mode: StatsMode) {
    this.statsModeChanged.emit(mode);
  }
}
